// @ts-nocheck
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { Stack, Center } from '@/components/ui/layout';
import { Title, Text, Button, Anchor } from '@/components/ui/core';
import { TextInput } from '@/components/ui/inputs';
import { IconMail, IconArrowLeft, IconKey } from '@tabler/icons-react';
import { AuthLayoutWrapper } from '../components';

export default function ForgotGradient() {
  const [email, setEmail] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Reset password for:', email);
  };

  return (
    <AuthLayoutWrapper
      variant="gradient"
      glassEffect
      gradientFrom="#f59e0b"
      gradientTo="#ef4444"
    >
      <Stack gap="lg">
        {/* Back button */}
        <Button
          component={Link}
          to="/app/demo/auth-pages/forgot-password"
          variant="subtle"
          size="xs"
          leftSection={<IconArrowLeft size={14} />}
          w="fit-content"
        >
          Back to variants
        </Button>

        {/* Header */}
        <Center>
          <Stack align="center" gap="xs">
            <Center
              style={{
                width: 72,
                height: 72,
                borderRadius: 20,
                background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
                boxShadow: '0 8px 24px rgba(239, 68, 68, 0.4)',
              }}
            >
              <IconKey size={36} color="white" />
            </Center>
            <Title order={2} ta="center" mt="md">Forgot password?</Title>
            <Text c="dimmed" size="sm" ta="center" maw={280}>
              Enter your email below and we'll send you instructions to reset your password.
            </Text>
          </Stack>
        </Center>

        {/* Form */}
        <form onSubmit={handleSubmit}>
          <Stack gap="md">
            <TextInput
              label="Email address"
              placeholder="your@email.com"
              leftSection={<IconMail size={16} />}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              size="md"
            />

            <Button
              type="submit"
              fullWidth
              size="md"
              variant="gradient"
              gradient={{ from: '#f59e0b', to: '#ef4444' }}
            >
              Send reset link
            </Button>
          </Stack>
        </form>

        {/* Back to Login */}
        <Center>
          <Anchor component={Link} to="/app/demo/auth-pages/login/gradient" size="sm">
            <IconArrowLeft size={14} style={{ marginRight: 4, verticalAlign: 'middle' }} />
            Back to sign in
          </Anchor>
        </Center>
      </Stack>
    </AuthLayoutWrapper>
  );
}
